import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getProfileTypes = () => async (dispatch) => {
    dispatch({
        type: 'PROFILETYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/profiletype/getall/', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'PROFILETYPE_GETALL_SUCCESS',
                payload: data.profileTypes
            })
        }
    } catch (error) {
        dispatch({
            type: 'PROFILETYPE_NOT_LOADING'
        })
    }
}

export const addProfileType = (profileTypedata) => async (dispatch) => {
    dispatch({
        type: 'PROFILETYPE_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/client/profiletype/register', profileTypedata, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'PROFILETYPE_ADD_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'PROFILETYPE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'PROFILETYPE_NOT_LOADING'
        })
    }
}

export const removeSkill = (typeskill, blockskill, skill, profileType) => async (dispatch) => {
    dispatch({
        type: 'PROFILETYPE_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/client/profiletype/removeskill/' + profileType, {'typeskill': typeskill, 'blockskill': blockskill, 'skill': skill}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'PROFILETYPE_EDIT_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'PROFILETYPE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'PROFILETYPE_NOT_LOADING'
        })
    }
}

export const removeProfileType = (idProfileType) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/client/profiletype/remove/' + idProfileType, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'PROFILETYPE_REMOVE_RESULT',
                payload: data
            })
            dispatch({
                type: 'PROFILETYPE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'PROFILETYPE_NOT_LOADING'
        })
    }
}